import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import {
  IEntradaLista,
  ITerminarSeguimiento,
} from "../../../../interfaces/despacho";
import { select, Store } from "@ngrx/store";
import { selectUsuario } from "../../../../states/usuario/selector";
import { AppState } from "../../../../app.state";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CommonModule } from "@angular/common";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { terminarSeguimientoDespacho } from "../../../../states/despacho/actions";
import { TruncatePipe } from "../../../../pipes/truncate.pipe";
import { TextFieldModule } from "@angular/cdk/text-field";
import { LoadingService } from "../../../../loading/loading.service";

@Component({
  selector: "app-terminar-seguimiento",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    TextFieldModule
  ],
  templateUrl: "./terminar-seguimiento.component.html",
  styleUrl: "./terminar-seguimiento.component.css",
})
export class TerminarSeguimientoComponent {
  public entradas: IEntradaLista[] = [];
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  motivoJustificacion = new FormControl("", [Validators.required]);
  public catJustificacion: any[] = [];

  entregables: any = [];
  selectAllChecked = false;

  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<TerminarSeguimientoComponent>,
    public dialog: MatDialog,
    public despachoService: DespachoService,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public loadingServe:LoadingService
  ) {}

  ngOnInit(): void {
    console.log("datalle", this.data);

    this.despachoService
      .listarEntradasConSeguimiento(this.data.id_tema)
      .subscribe((data) => {
        console.log("data", data.entradas);
        this.entradas = data.entradas.map((entrada: IEntradaLista) => {
          return { ...entrada, selected: false };
        });
      });
  }

  selectAll(checked: boolean): void {
    this.entradas.forEach((entrada: IEntradaLista) => {
      entrada.selected = checked;
    });
    this.selectAllChecked = checked;
  }

  updateSelectAllState(): void {
    const allSelected = this.entradas.every((entrada: any) => entrada.selected);
    this.selectAllChecked = allSelected;
  }

  getEntradasChecked(): any {
    return this.entradas.filter((entrada: IEntradaLista) => entrada.selected);
  }
  async save() {
    this.loadingServe.show()
    this.dialogRef.close();
    const user = structuredClone(this.stateUser.state().usuario);
    console.log("user", user);
    console.log("getEntregaablesChecked", this.getEntradasChecked());

    const seguimiento: ITerminarSeguimiento = {
      id_tema: this.data.id_tema,
      id_usuario: user.uid,
      justificacion: this.motivoJustificacion?.value ?? "",
      usuario: user.nombre,
      entradas: [...this.getEntradasChecked()],
    };
    console.log("payload", seguimiento);
    try {
      const terminarSeguimiento =
        await this.despachoService.terminarSeguimiento(seguimiento);
      if (!terminarSeguimiento.error) {
        this.store.dispatch(terminarSeguimientoDespacho({ seguimiento }));
      }
    } catch (error) {}
  }
}
